import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=4aea6c2a&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
import style0 from "./Home.vue?vue&type=style&index=0&id=4aea6c2a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aea6c2a",
  null
  
)

export default component.exports